module.exports = __webpack_public_path__ + "img/printer-icon-black.31e249c0.svg";